import React from 'react';
import { FileDown } from 'lucide-react';
import { TabPastelExport } from './Billing';

// Standalone page for the Pastel export (grouped under Reports).
export default function PastelExport() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <FileDown size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Pastel Export</h1>
          <p className="text-xs text-gray-400">Export a period&apos;s books for Sage Pastel Partner</p>
        </div>
      </div>
      <TabPastelExport />
    </div>
  );
}
